<template>
  <modal :titulo="titulo" id="detalhes-indisponibilidade" class="modal-detalhes-entidade"
         :loading="loading">
    <template #title-extra>
      <div v-if="indisponibilidadeOrdem.cancelado" class="badge badge-danger-soft text-center m-0" >
        Cancelada
      </div>
    </template>
    <template v-if="!loading && !auditoria">

      <card titulo="Informações Adicionais">

          <template #acoes>

            <a class="icon ml-1 float-right"  @click.prevent="salvarInfoAdicionais()">
              SALVAR
            </a>

            <a class="icon ml-1 float-right" style="padding-right: 10px"  @click="close()">
              CANCELAR
            </a>

          </template>

        <card-content>
          <div class="row gutters-xs">
          <v-input class="col form-group" label="Juízo" v-model="indisponibilidadeOrdem.juizo" type="text" />
          </div>

          <div class="row gutters-xs" v-if="!indisponibilidadeOrdem.solicitante">
            <v-input class="col form-group" label="Solicitante"  >
              <buscar-pessoa ref="buscar-solicitante" :default-query="indisponibilidadeOrdem.nomeSolicitante || ''" @add="selecionarSolicitante($event)" :novo="true" />
            </v-input>
          </div>

          <div class="row gutters-xs" v-else>
            <v-input class="col form-group" label="Solicitante">
              <input type="text" readonly v-model="indisponibilidadeOrdem.solicitante.nome" class="form-control form-control-xs" />
            </v-input>

            <div class="col-auto mt-1">
              <button class="btn btn-outline-secondary btn-xs" style="margin-top: 22px" @click="removerSolicitante" type="button" title="Remover">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
        </card-content>
      </card>

      <card titulo="Cancelamento" v-if="motivo">
        <span v-if="cancelamento.usuarioCancelamento"><b>Usuário:</b> {{cancelamento.usuarioCancelamento}}</span>
        <span> | <b>Data:</b> {{cancelamento.cancelamento | datahora }}</span>
        <span> | <b>Motivo:</b> {{cancelamento.motivoCancelamento}}</span>
      </card>

      <card titulo="Dados Gerais">
        <card-content>

          <p class="semi-bold" v-if="indisponibilidadeOrdem.tipo != 'CNIB'">
            <span>Tipo de Cadastro: </span><span>{{indisponibilidadeOrdem.tipo}}</span>
          </p>

          <p class="semi-bold">
            <span>Protocolo Indisponibilidade: </span><span>{{indisponibilidadeOrdem.protocoloCnib}}</span>
          </p>

          <p class="semi-bold" v-if="indisponibilidadeOrdem.protocoloCnibCancelado">
            <span>Protocolo Indisponibilidade cancelado: </span><span>{{indisponibilidadeOrdem.protocoloCnibCancelado}}</span>
          </p>

          <p class="semi-bold">
            <span>Data da importação: </span><span>{{indisponibilidadeOrdem.cadastro | datahora}}</span>
          </p>

          <p class="semi-bold">
            <span>Data do pedido: </span><span>{{indisponibilidadeOrdem.pedido | data}}</span>
          </p>

          <p class="semi-bold">
            <span>Data do pedido de cancelamento: </span><span>{{indisponibilidadeOrdem.cancelamento | data}}</span>
          </p>

          <p class="semi-bold">
            <span>Instituição: </span><span>{{indisponibilidadeOrdem.instituicao}}</span>
          </p>

          <p class="semi-bold">
            <span>Fórum / Vara: </span><span>{{indisponibilidadeOrdem.forumVara}}</span>
          </p>

          <p class="semi-bold">
            <span>Usuário: </span><span>{{indisponibilidadeOrdem.nomeUsuario}}</span>
          </p>

          <p class="semi-bold">
            <span>Nº processo: </span><span>{{indisponibilidadeOrdem.numeroProcesso}}</span>
          </p>

          <p class="semi-bold" v-if="indisponibilidadeOrdem.email">
            <span>E-mail: </span><span>{{indisponibilidadeOrdem.email}}</span>
          </p>

          <p class="semi-bold" v-if="indisponibilidadeOrdem.telefone">
            <span>Telefone: </span><span>{{indisponibilidadeOrdem.telefone}}</span>
          </p>

          <p class="semi-bold" v-if="indisponibilidadeOrdem.observacao">
            <span>Observações: </span><span>{{indisponibilidadeOrdem.observacao}}</span>
          </p>

        </card-content>
      </card>


      <card titulo="Envolvidos">
        <card-table class="table-borderless mb-1" v-if="indisponibilidadeOrdem.individuos.length > 0">

          <thead>
            <tr>
              <th width="400px">Nome</th>
              <th width="200px">Documento</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="pessoa in indisponibilidadeOrdem.individuos" :key="pessoa.id">
              <td><a class="mb-1">{{pessoa.nome}}</a></td>
              <td> {{pessoa.documento}}</td>
            </tr>
          </tbody>

        </card-table>
      </card>

      <card titulo="Indicadores Pessoais Encontrados">
        <consulta-indisponibilidade-ordem-pessoas
          ref="consultaPessoas"
          :ordem-id="id"
          :tipo-cancelamento="indisponibilidadeOrdem.tipoCancelamento"
          :protocolo-cnib-cancelado="!!indisponibilidadeOrdem.protocoloCnibCancelado"
          :dominio="dominio"
          @detalhes-pessoa="detalhesPessoa"
          @detalhes-ficha="detalhesFicha"
          @cancelar-indisponibilidade="cancelarIndisponibilidade"
          @desfazer-cancelamento-indisponibilidade="desfazerCancelamentoIndisponibilidade"
        />
      </card>

      <card titulo="Protocolos Gerados">
        <template #acoes>

          <a class="icon ml-1 float-right"  @click.prevent="vincularProtocolo()" v-if="!$root.isAuditorOnly">
            NOVO VÍNCULO
          </a>

        </template>
        <card-table class="table-borderless mb-1" v-if="indisponibilidadeOrdem.protocolos.length > 0">

          <thead>
            <tr>
              <th>Código</th>
              <th>Ato Principal</th>
              <th>Status</th>
              <th>Usuário</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="protocolo in indisponibilidadeOrdem.protocolos" :key="protocolo.id">
              <td>
                <a :href="`${$root.publicPath}#/protocolo/${protocolo.id}/geral`" target="_blank" class="mb-1 pointer">{{nomearProtocolo(protocolo.dominio, protocolo.tipoProtocolo, protocolo.codigo)}}</a>
              </td>
              <td>{{protocolo.tipoServico}}</td>
              <td>{{protocolo.status}}</td>
              <td>{{protocolo.atendente}}</td>
              <td>
                <a v-if="usuarioAdminOuGestor && !$root.isAuditorOnly" @click.prevent="desvincularProtocolo(protocolo)" class="icon" title="Desvincular Protocolo">
                  <i class="fa fa-unlink"></i>
                </a>
              </td>
            </tr>
          </tbody>

        </card-table>

        <div class="alert alert-warning mb-0" role="alert" v-else>
          Nenhum protocolo gerado
        </div>

      </card>

    </template>
    <auditoria-pagination v-if="!loading && auditoria" :referencia="id" entidade="INDISPONIBILIDADE" />
    <template #footer>
      <v-button v-if="!$root.isAuditorOnly" v-show="!auditoria" class="btn btn-outline-primary btn-xs mr-auto" :run="showAuditorias">
        Auditoria
      </v-button>
      <template v-if="!auditoria">
        <v-button class="btn btn-outline-success btn-xs ml-auto" v-if="ignorar && usuarioAdminOuGestor" :run="reativar" :popover="true">
          Reativar sugestão ignorada
        </v-button>
        <v-button v-if="!$root.isAuditorOnly && !indisponibilidadeOrdem.cancelado" :class="`btn btn-outline-primary btn-xs ml-${ignorar ? '2' : 'auto'}`" :run="gerarProtocolo" :popover="true">
          Protocolar
        </v-button>
        <v-button v-if="!$root.isAuditorOnly && !indisponibilidadeOrdem.tipoCancelamento && !indisponibilidadeOrdem.cancelado" :class="`btn btn-outline-danger btn-xs ml-2`" :run="cancelarOrdem">
          Cancelar Ordem
        </v-button>
        <v-button v-if="!indisponibilidadeOrdem.tipoCancelamento && indisponibilidadeOrdem.cancelado" label="Desfazer cancelamento da ordem?"
                  class="btn btn-outline-primary btn-xs ml-auto" :popover="true" :run="desfazerCancelamentoOrdem">
          Desfazer Cancelamento
        </v-button>
      </template>
      <template v-else>
        <v-button class="btn btn-outline-primary btn-xs mr-auto" :run="showAuditorias">
          Voltar
        </v-button>
      </template>
    </template>
  </modal>
</template>

<script>
  import FrontBusiness from "@/business/FrontBusiness";
  import IndisponibilidadeBusiness from "@/business/IndisponibilidadeBusiness";
  import Utils from "@/commons/Utils";
  import DetalhesIndicadorPessoal from "@/components/IndicadorPessoal/Detalhes/DetalhesIndicadorPessoal";
  import DetalhesIndicadorReal from "@/components/IndicadorReal/Detalhes/DetalhesIndicadorReal";
  import ModalCancelarIndisponibilidade from "@/components/Indisponibilidade/ModalCancelarIndisponibilidade.vue";
  import ModalCancelarOrdem from "@/components/Indisponibilidade/ModalCancelarOrdem.vue";
  import ModalVincularIndisponibilidade from "@/components/Indisponibilidade/ModalVincularIndisponibilidade.vue";
  import ModalSelecionarDominioProtocolo from "@/components/Indisponibilidade/ModalSelecionarDominioProtocolo.vue";
  import Card from "@/components/Layout/components/Card.vue";
  import CardContent from "@/components/Layout/components/CardContent.vue";
  import CardTable from "@/components/Layout/components/CardTable.vue";
  import Modal from "@/components/Modal";
  import ModalVinculoSolicitante from "@/components/Indisponibilidade/ModalVinculoSolicitante.vue";
  import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
  import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness";
  import ConsultaIndisponibilidadeOrdemPessoas from "@/components/Indisponibilidade/Consultas/ConsultaIndisponibilidadeOrdemPessoas.vue";
  import ConsultaIndisponibilidadeOrdemFichas
    from "@/components/Indisponibilidade/Consultas/ConsultaIndisponibilidadeOrdemFichas.vue";

  export default {
    name: "DetalhesIndisponibilidade",
    components: {
      ConsultaIndisponibilidadeOrdemPessoas, CardTable, CardContent, Card, Modal,
      AuditoriaPagination: () => import('@/v2/components/Auditoria/AuditoriaPagination')
    },

    modal:{
      width: 900
    },

    props: {
        id: String,
        ignorar: Boolean,
        origem: { type: String, default: null },
        protocoloDominio: { type: String, default: null }
    },

    computed: {
      dominio() {
        if (this.origem === 'ENVOLVIDO_RTD') return 'RTD';
        if (this.origem === 'ENVOLVIDO_RCPJ') return 'RCPJ';
        if (this.protocoloDominio === 'PROTOCOLO_RTD') return 'RTD';
        if (this.protocoloDominio === 'PROTOCOLO_RCPJ') return 'RCPJ';
        if (this.protocoloDominio === 'PROTOCOLO_RI') return 'RI';
        if (this.origem) return 'RI';
        return null;
      },

      dominioProtocolo() {
        const map = { RI: 'PROTOCOLO_RI', RTD: 'PROTOCOLO_RTD', RCPJ: 'PROTOCOLO_RCPJ' };
        return this.dominio ? map[this.dominio] : null;
      },

      titulo() {
        return 'Indisponibilidade';
      },

      motivo(){
        return this.indisponibilidadeOrdem.motivoCancelamento || this.indisponibilidadeOrdem?.indisponibilidades?.[0]?.motivo
      },

      cancelamento() {
        if (this.indisponibilidadeOrdem.motivoCancelamento) {
          return this.indisponibilidadeOrdem
        }
        return this.indisponibilidadeOrdem?.indisponibilidades?.[0]
      },

      usuario() {
        return this.$root.usuarioLogado;
      },

      usuarioAdminOuGestor(){
        return this.usuario.administrador || this.usuario.gestor;
      }
    },

    data() {
      return {
        indisponibilidadeOrdem: {},
        pessoasIndisponibilidade: null,
        fichas: null,
        loading: true,
        item: null,
        auditoria: false,
        cancelamentoIndisponibilidadeEmAndamento: false,
      }
    },

    async beforeMount() {
      await this.load();
    },

    methods: {

      async load() {
        this.$set(this, 'loading', true);

        this.indisponibilidadeOrdem = await IndisponibilidadeBusiness.getResumoById(this.id);
        this.indisponibilidadeOrdem.juizo = this.indisponibilidadeOrdem.juizo || '' ;

        this.pessoasIndisponibilidade = [];

        await IndisponibilidadeBusiness.getIndividuosByOrdem(this.id).then(l => {
          this.indisponibilidadeOrdem.individuos = l || [];
          Utils.sortAlphanumeric(this.indisponibilidadeOrdem?.individuos, 'nome');
        });

        const p2 = IndisponibilidadeBusiness.getProtocolosByOrdem(this.id, this.dominioProtocolo).then(l => {
          this.indisponibilidadeOrdem.protocolos = l || [];
          Utils.orderFields(this.indisponibilidadeOrdem.protocolos, ['codigo']);
        });

        await Promise.all([p2]);

        this.$set(this, 'loading', false);
      },

      selecionarSolicitante(solicitante){
          this.$set(this.indisponibilidadeOrdem, 'solicitante', solicitante);
      },

      removerSolicitante(){
          this.$set(this.indisponibilidadeOrdem, 'solicitante', null);
      },

      close(retorno) {
        FrontBusiness.closeModal(retorno);
      },

      detalhesPessoa(pessoa) {
        if(pessoa.indicadorPessoalId){
          FrontBusiness.openModal(DetalhesIndicadorPessoal, {id: pessoa.indicadorPessoalId});
        }
      },

      detalhesFicha(ficha) {
        if(ficha.indicadorRealId){
          FrontBusiness.openModal(DetalhesIndicadorReal, {id: ficha.indicadorRealId});
        } else if (ficha.indicadorId) {
          const componente = IndicadorBusiness.getDetalhesIndicador(ficha.livro);
          if (componente) {
            FrontBusiness.openModal(componente, {id: ficha.indicadorId});
          }
        }
      },

      abrirProtocolo(id){
        if(id){
          FrontBusiness.redirect(`protocolo/${id}/geral`);
        }
      },

      nomearFicha: FrontBusiness.nomearFicha,
      nomearProtocolo: FrontBusiness.nomearProtocolo,

      async salvarInfoAdicionais(){
          let r = await IndisponibilidadeBusiness.salvarInfoAdicionais(this.indisponibilidadeOrdem)
            .catch(e => FrontBusiness.fullErrorHandler(this, e));
          if(r){
            this.close();
          }
      },

      async gerarProtocolo(){
        let nomeSolicitante = this.$refs?.["buscar-solicitante"]?.query;
        if (nomeSolicitante && !this.indisponibilidadeOrdem?.solicitante?.id) {
          let pessoas = await IndisponibilidadeBusiness.sugerirSolicitante({nome: nomeSolicitante, tipo: 'JURIDICA'});

          if(pessoas.length > 1) {
            this.indisponibilidadeOrdem.solicitante = await FrontBusiness.openModal(ModalVinculoSolicitante, {pessoas: pessoas});
          } else {
            this.indisponibilidadeOrdem.solicitante = pessoas[0] || await IndicadorPessoalBusiness.criarIndicador({
              documentoDesconhecido: true,
              nome: nomeSolicitante,
              indicadorPessoal: {
                nome: nomeSolicitante,
                documentoDesconhecido: true,
                tipoPessoa: 'JURIDICA'
              },
              tipoPessoa: 'JURIDICA'
            });
          }
        }

        let r = await IndisponibilidadeBusiness.salvarInfoAdicionais(this.indisponibilidadeOrdem)
          .catch(e => FrontBusiness.fullErrorHandler(this, e));

        if(r){
          const dominio = await this.selecionarDominioProtocolo();
          if (!dominio) {
            return;
          }

          let resultado = await this.gerarProtocoloPorDominio([this.indisponibilidadeOrdem.id], dominio).catch(e => {
            FrontBusiness.showError('', e.message);
            return false;
          });

          if(resultado){
            await IndisponibilidadeBusiness.atualizarIndicadores('reset-view').catch(e => null);
            await this.$router.push({name: 'protocolo', params: {id: resultado[0]}});
            window.location.reload();
          }
        }

      },

      async selecionarDominioProtocolo() {
        if (this.dominio) {
          return this.dominio;
        }

        return FrontBusiness.openModal(ModalSelecionarDominioProtocolo, {
          ordemId: this.indisponibilidadeOrdem.id,
          tipoCancelamento: this.indisponibilidadeOrdem.tipoCancelamento
        });
      },

      gerarProtocoloPorDominio(ordens, dominio) {
        if (dominio === 'RTD') {
          return IndisponibilidadeBusiness.gerarProtocoloRtd(ordens, true);
        }
        if (dominio === 'RCPJ') {
          return IndisponibilidadeBusiness.gerarProtocoloRcpj(ordens, true);
        }
        if (dominio === 'RI') {
          return IndisponibilidadeBusiness.gerarProtocolo(ordens, true);
        }
        return Promise.reject(new Error('Domínio da indisponibilidade não informado'));
      },

      async vincularProtocolo(){
        let resultado = await FrontBusiness.openModal(ModalVincularIndisponibilidade, {id: this.indisponibilidadeOrdem.id});
        if(resultado){
          await IndisponibilidadeBusiness.atualizarIndicadores('reset-view').catch(e => null);
          this.close(true);
        }
      },

      async reativar(){
        let retorno = await IndisponibilidadeBusiness
          .reativar(this.indisponibilidadeOrdem.id)
          .catch(this.showError);

        if(retorno){
          FrontBusiness.showSuccess('', 'Sugestão reativada');
          this.close(true);
        }

      },

      async cancelarIndisponibilidade(pessoa, ficha, individuo = false) {
        if (this.cancelamentoIndisponibilidadeEmAndamento) {
          return false;
        }
        this.$set(this, 'cancelamentoIndisponibilidadeEmAndamento', true);
        try {
          let ids = [];
          let indisponibilidadeIndividuos = [];
          if (ficha?.indicadorRealId || ficha?.indicadorId) {
            ids.push(ficha.indisponibilidade);
          } else {
            ids = await this.getIdsIndisponibilidadesPessoa(pessoa, false);
          }
          if (individuo) {
            indisponibilidadeIndividuos = (this.indisponibilidadeOrdem.individuos || []).filter(c => c.documento === pessoa.documento).map( i =>  i.id );
          }
          let response = await FrontBusiness.openModal(ModalCancelarIndisponibilidade, {indisponibilidadeIndividuos, ids, ordem: this.id});
          if (response) {
            await this.load();
            await this.$refs?.consultaPessoas?.reload();
          }
          return response;
        } finally {
          this.$set(this, 'cancelamentoIndisponibilidadeEmAndamento', false);
        }
      },

      async desfazerCancelamentoIndisponibilidade(pessoa, ficha, individuo = false) {
        if (this.cancelamentoIndisponibilidadeEmAndamento) {
          return false;
        }
        this.$set(this, 'cancelamentoIndisponibilidadeEmAndamento', true);
        try {
          return await FrontBusiness.showConfirmacao("", "Desfazer cancelamento da indisponibilidade?").then(async r => {
            if (r.value) {
              let ids = [], indisponibilidadeIndividuos = [];
              if (ficha?.indicadorRealId || ficha?.indicadorId) {
                ids.push(ficha.indisponibilidade);
              } else {
                ids = await this.getIdsIndisponibilidadesPessoa(pessoa, true);
              }
              if (individuo) {
                indisponibilidadeIndividuos = (this.indisponibilidadeOrdem.individuos || []).filter(c => c.documento === pessoa.documento).map( i =>  i.id );
              }
              let retorno = await IndisponibilidadeBusiness.desfazerCancelamentoIndisponibilidade({
                individuos: indisponibilidadeIndividuos,
                indisponibilidades: ids,
                ordem: this.id
              }).catch(this.showError);
              if(retorno){
                await this.load();
                await this.$refs?.consultaPessoas?.reload();
              }
              return true;
            } else if (r.dismiss === 'cancel') {
              return false;
            } else {
              return true;
            }
          }).catch(this.showError)
        } finally {
          this.$set(this, 'cancelamentoIndisponibilidadeEmAndamento', false);
        }
      },

      async getIdsIndisponibilidadesPessoa(pessoa, cancelamento) {
        const result = await IndisponibilidadeBusiness.getIdsIndisponibilidadesOrdemPessoa({
          ordemId: this.id,
          tipoCancelamento: this.indisponibilidadeOrdem.tipoCancelamento,
          indicadorPessoalId: pessoa?.indicadorPessoalId,
          individuoId: pessoa?.individuoId,
          cancelamento,
        }).catch(this.showError);

        return result || [];
      },

      async cancelarOrdem() {
        let response = await FrontBusiness.openModal(ModalCancelarOrdem, {id: this.indisponibilidadeOrdem.id});
        if (response) {
          await this.load();
        }
      },

      async desfazerCancelamentoOrdem() {
        let retorno = await IndisponibilidadeBusiness.desfazerCancelamentoOrdem(this.indisponibilidadeOrdem.id).catch(this.showError);
        if(retorno){
          await this.load();
        }
      },

      async desvincularProtocolo(protocolo) {
        return FrontBusiness.showConfirmacao("", "Desfazer desvincular o protocolo da indisponibilidade?").then(async r => {
          if (r.value) {
            let retorno = await IndisponibilidadeBusiness.desvincularProtocolo(this.indisponibilidadeOrdem.id, protocolo.id).catch(this.showError);
            if(retorno){
              await this.load();
            }
            return true;
          } else if (r.dismiss === 'cancel') {
            return false;
          } else {
            return true;
          }
        }).catch(this.showError)
      },

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e, '');
      },

      showAuditorias(){
        this.auditoria = !this.auditoria;
      },

      toggleBuscaMatricula() {
        if (this.buscaMatriculaVisivel && this.buscaMatricula?.trim()) {
          this.buscarIndicadorReal();
        } else {
          this.buscaMatriculaVisivel = !this.buscaMatriculaVisivel;
          if (!this.buscaMatriculaVisivel) {
            this.buscaMatricula = '';
            this.mensagemBusca = '';
          }
        }
      },

      async buscarIndicadorReal() {
        if (!this.buscaMatricula?.trim()) return;

        const codigos = this.buscaMatricula.split(',')
          .map(c => c.trim().replace(/[^0-9]/g, ''))
          .filter(c => c);
        if (!codigos.length) return;

        const codigosStr = codigos.join(',');
        const result = await IndisponibilidadeBusiness.paginationIndisponibilidadeOrdemFicha(
          'codigo', 'asc', 0, 100,
          { filtros: { ordemId: this.id, codigos: codigosStr, dominio: this.dominio } }
        );

        const encontrados = (result.pagina || []).map(f => String(f.codigo));
        const naoEncontrados = codigos.filter(c => !encontrados.includes(c));

        if (naoEncontrados.length) {
          this.mensagemBusca = 'Código(s) não encontrado(s) ' + naoEncontrados.join(', ');
        } else {
          this.mensagemBusca = '';
        }

        if (encontrados.length) {
          await FrontBusiness.openConsulta(
            ConsultaIndisponibilidadeOrdemFichas,
            {
              ordemId: this.id,
              codigos: codigosStr,
              dominio: this.dominio,
              protocoloCnibCancelado: !!this.indisponibilidadeOrdem.protocoloCnibCancelado,
              onCancelarIndisponibilidade: this.cancelarIndisponibilidade,
              onDesfazerCancelamento: this.desfazerCancelamentoIndisponibilidade,
              onDetalhesFicha: this.detalhesFicha,
            }
          );
        }
      },

      async abrirFichasPessoa(pessoa) {
        await FrontBusiness.openConsulta(
          ConsultaIndisponibilidadeOrdemFichas,
          {
            pessoa,
            indisponibilidadeId: pessoa.indisponibilidadeId,
            dominio: this.dominio,
            protocoloCnibCancelado: !!this.indisponibilidadeOrdem.protocoloCnibCancelado,
            onCancelarIndisponibilidade: this.cancelarIndisponibilidade,
            onDesfazerCancelamento: this.desfazerCancelamentoIndisponibilidade,
            onDetalhesFicha: this.detalhesFicha,
          }
        );
      },


    },

  }
</script>

<style lang="scss" scoped>

.fichas-scroller{
  max-height: 200px;
}

.fichas-scroller .ficha-item{
  padding: 8px 15px;
  margin-bottom: 5px;
}

.tbl-indisp {
  padding: 0;
  td {
    padding-bottom: 0;
  }
}
</style>
